module.exports = __webpack_public_path__ + "static/media/class_job_017.c9679b78.svg";